import type { TabOptionsType } from 'components/organisms/pageTabs/types'

export const getTabOption = ({
  tabOptions,
  selectedTab,
}: {
  tabOptions: TabOptionsType;
  selectedTab: string;
}) => {
  const tabKey = Object.keys(tabOptions).find(it => tabOptions[it].key === selectedTab) || ''

  return tabOptions[tabKey]
}
